import {createFileRoute} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId',
)({
  staticData: {crumbKey: 'navigation.credit-account'},
});
